export default __webpack_public_path__ + "bec34ad830000d4c0fed15a8fdf041d7.png";